import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import EditableInfo from "@builder/components/editable/EditableInfo";
import { EditableProps } from "@builder/components/editable/editableProps";
import LoaderButton from "@builder/components/general/Button/LoaderButton";
import OliverText from "@builder/components/general/OliverText";
// import SelectImage from "@builder/components/general/SelectImage";
// import { setCurrentPopup, setImageState } from "@builder/store/slices/popupSlice";
import TextInput from "@builder/components/general/TextInput";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { IframeNode } from "@common/build/types";
import { useState } from "react";
import "./style.css";

const EditIframe = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const iframe = useAppSelector(getSelectedNode) as IframeNode;
    const [iframeUrl, setIframeUrl] = useState(iframe.iframeUrl);

    const loadURL = () => {
        if (iframeUrl === iframe.iframeUrl) return;
        setLoading(true);
        dispatch(updateNodeProperty({ propertyPath: ["iframeUrl"], value: iframeUrl }));
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };

    // const imageCallback = () => {
    //     dispatch(setImageState(null));
    //     dispatch(setCurrentPopup("images"));
    // };

    // const removeImageCallback = () => {
    //     dispatch(updateNodeProperty({ propertyPath: ["image"], value: "", remove: true }));
    // };

    return (
        <SidebarCollapse title="Iframe" parent={parent}>
            <EditableInfo header="iframeNoticeHeader" body="iframeNoticeBody" />
            <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                <OliverText text="Load URL/IP" size="s" />
                <OliverText text="Point to a site or IP below that you want to load in a the frame." size="xs" />
                <TextInput callback={setIframeUrl} placeholder="https://finalpos.com" value={iframeUrl} noTranslate />
            </div>
            <LoaderButton onClick={loadURL} text="Load Frame" isLoading={loading} />
            {/* <SelectImage 
                label="Select image to show when offline"
                type="image"
                callback={imageCallback}
                removeCallback={removeImageCallback}
                img={iframe.image?.url}
            /> */}
        </SidebarCollapse>
    );
};

export default EditIframe;
